import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { AuthService } from '@app-services/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
	get as _get
} from 'lodash';
import { NbDialogService, NbGlobalPhysicalPosition, NbGlobalPosition, NbToastrService } from '@nebular/theme';
import { Store, select } from '@ngrx/store';
import { NbComponentStatus } from '@nebular/theme';
import * as fromAuth from '@app-stores/reducers/auth';
import * as Auth from '@app-stores/actions/auth.action';
import { TranslationService } from "@app-services/translation.service";


@Component({
	selector: 'crm-request-password',
	templateUrl: './request-password.component.html',
	styleUrls: ['./request-password.component.scss'],
})
export class RequestPasswordComponent implements OnInit, OnDestroy {

	form: UntypedFormGroup;
	loading = false;
	errorMessage: string = '';
	private _duration = 2000;
	private _position: NbGlobalPosition = NbGlobalPhysicalPosition.TOP_RIGHT;
	private _preventDuplicates = false;
	// getForgottenPasswordVerificationPending$ = this._store.pipe(select(fromAuth.getForgottenPasswordVerificationPending));
	// getForgottenPasswordVerificationSent$ = this._store.pipe(select(fromAuth.getForgottenPasswordVerificationSent));
	// getForgottenPasswordError$ = this._store.pipe(select(fromAuth.getForgottenPasswordError));

	submitted = false;

	// Private
	private _viewInited: boolean = false;
	private _unsubscribeAll: Subject<any>;


	constructor(
		private _router: Router,
		private auth: AuthService,
		private _formBuilder: UntypedFormBuilder,
		private _store: Store<fromAuth.AuthState>,
		private _toastrService: NbToastrService,
		private _translationService: TranslationService,

	) {
		this.form = this._formBuilder.group({
			email: ['', [Validators.required, Validators.email]],
		});
		// Set the private defaults
		this._unsubscribeAll = new Subject();
	}

	ngOnInit() {

		this._viewInited = true;
	}

	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	onRequest() {
		if (this.form.invalid)
			return;
		this.submitted = true;
		this.errorMessage = null;

		this.auth.requestpassword(this.form.value.email).pipe(takeUntil(this._unsubscribeAll)).subscribe((res: any) => {
			if (res.success == false) {
				// this.showToast(NbToastStatus.SUCCESS, 'Success', res.message);
				this.showToast('danger', this._translationService.translate('Common.Failed'), this._translationService.translate(`Common.${res.message}`));
			} else {
				this.showToast('success', this._translationService.translate('Common.Success'), this._translationService.translate(`Common.${res.message}`));
				this._router.navigate(['/recover-password']
					, {
						queryParams: { email: this.form.value.email },
					})
			}
		}, (err) => {

		});
	}

	private showToast(type: NbComponentStatus, title: string, body: string) {
		const config = {
			status: type,
			destroyByClick: true,
			duration: this._duration,
			hasIcon: true,
			position: this._position,
			preventDuplicates: this._preventDuplicates,
		};
		const titleContent = title ? `. ${title}` : '';

		this._toastrService.show(
			body,
			`${titleContent}`,
			config);
	}
}
